"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityHouse = void 0;
const types_1 = require("../../types");
const abi_1 = require("@ethersproject/abi");
const base_1 = require("./base");
const protocol_1 = require("@prophouse/protocol");
class CommunityHouse extends base_1.HouseBase {
    /**
     * Returns a `CommunityHouse` instance for the provided chain configuration
     * @param chainId
     */
    static for(config) {
        return new CommunityHouse(config);
    }
    /**
     * The house type
     */
    get type() {
        return types_1.HouseType.COMMUNITY;
    }
    /**
     * The house implementation contract address
     */
    get impl() {
        return this._addresses.evm.house.community;
    }
    /**
     * ABI-encode the community house configuration
     * @param config The community house config
     */
    encode(config) {
        if (!this.isValidURI(config.contractURI)) {
            throw new Error(`Invalid contract URI: ${config.contractURI}`);
        }
        return abi_1.defaultAbiCoder.encode(['string'], [config.contractURI]);
    }
    /**
     * Given a house address, return a `CommunityHouse` contract instance
     * @param address The house address
     */
    getContract(address) {
        return protocol_1.CommunityHouse__factory.connect(address, this._evm);
    }
}
exports.CommunityHouse = CommunityHouse;
